import { useCallback, useEffect, useState } from "react";
import { useGetAllVendorNameOrIdQuery } from "../../api/api";
import { truncateString } from "../../lib/utils";
import GenericDropdown from "../GenericDropDown";

interface VendorsListDropdownProps {
  onVendorChange: (vendorId: string) => void;
  selectedVendorId?: string;
  className?: string;
  placeholder?: string;
  showAllOption?: boolean;
  userRole?: string;
  vendorId?: string;
}

export const VendorsListDropdown = ({
  onVendorChange,
  selectedVendorId,
  className = "",
  placeholder = "Select a vendor",
  showAllOption = true,
  userRole = "",
  vendorId = "",
}: VendorsListDropdownProps) => {
  const [selectedVendorName, setSelectedVendorName] = useState<string>("");

  const { data: vendorResponse } = useGetAllVendorNameOrIdQuery(undefined, {
    skip: userRole === "ADMIN" ? false : true,
  });

  const vendorList = vendorResponse?.data || [];

  const handleVendorChange = (value: string) => {
    onVendorChange(value);
    if (value === "-1") {
      setSelectedVendorName("");
    } else {
      const vendor = vendorList.find((v) => v.id.toString() === value);
      setSelectedVendorName(vendor ? truncateString(vendor.company, 15) : "");
    }
  };

  useEffect(() => {
    if (selectedVendorId && vendorList.length > 0) {
      const vendor = vendorList.find(
        (v) => v.id.toString() === selectedVendorId
      );
      setSelectedVendorName(vendor ? truncateString(vendor.company, 15) : "");
    }
  }, [selectedVendorId, vendorList]);

  return (
    <GenericDropdown
      labelValue={selectedVendorName}
      onChange={handleVendorChange}
      options={vendorList.map((vendor) => ({
        value: vendor.id.toString(),
        label: vendor.company,
      }))}
      placeholder={placeholder}
      error={false}
      className={`text-black bg-white h-9 justify-center items-center ${className}`}
      showAllOption={showAllOption}
    />
  );
};
